import { render, staticRenderFns } from "./DirectionsOfUseTab.vue?vue&type=template&id=cdf4b8c2&scoped=true"
import script from "./DirectionsOfUseTab.vue?vue&type=script&lang=js"
export * from "./DirectionsOfUseTab.vue?vue&type=script&lang=js"
import style0 from "./DirectionsOfUseTab.vue?vue&type=style&index=0&id=cdf4b8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf4b8c2",
  null
  
)

export default component.exports